import { AgePyramid } from '../../Common/Charts/AgePyramid';
import { usePacientProfileChartsDataContext } from './hooks/usePacientProfileChartsDataContext';

export const PatientAgePyramid = () => {
    const { chartData } = usePacientProfileChartsDataContext();

    const piramideEtaria = chartData?.agePyramid || {};
    const categories = piramideEtaria.faixas || [];
    const male = piramideEtaria.masculino || [];
    const female = piramideEtaria.feminino || [];

    return (
        <AgePyramid
            title={'Pirâmide Etária dos Pacientes'}
            categories={categories}
            male={male}
            female={female}
            maleColor={'#0D82D3'}
            femaleColor={'#D6588F'}
        />
    );
};
